import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { DriverNodeFragmentDoc } from '../fragments/driverNode.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DriverQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DriverQuery = { __typename?: 'Query', driver?: { __typename?: 'DriverNode', id: string, address?: string | null, additionalAddress?: string | null, city?: string | null, zip?: number | null, country?: string | null, phone?: string | null, name: string, email?: string | null, idNumber?: string | null, birthday?: any | null, customer: { __typename?: 'CustomerNode', id: string, name: string } } | null };


export const DriverDocument = gql`
    query Driver($id: ID!) {
  driver(id: $id) {
    ...DriverNode
  }
}
    ${DriverNodeFragmentDoc}`;

/**
 * __useDriverQuery__
 *
 * To run a query within a React component, call `useDriverQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriverQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDriverQuery(baseOptions: Apollo.QueryHookOptions<DriverQuery, DriverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriverQuery, DriverQueryVariables>(DriverDocument, options);
      }
export function useDriverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriverQuery, DriverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriverQuery, DriverQueryVariables>(DriverDocument, options);
        }
export type DriverQueryHookResult = ReturnType<typeof useDriverQuery>;
export type DriverLazyQueryHookResult = ReturnType<typeof useDriverLazyQuery>;
export type DriverQueryResult = Apollo.QueryResult<DriverQuery, DriverQueryVariables>;